import { render, staticRenderFns } from "./SubmissionContentLayoutSelector.vue?vue&type=template&id=78a955c0&scoped=true&"
import script from "./SubmissionContentLayoutSelector.vue?vue&type=script&lang=js&"
export * from "./SubmissionContentLayoutSelector.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionContentLayoutSelector.vue?vue&type=style&index=0&id=78a955c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a955c0",
  null
  
)

export default component.exports